import {TrainService} from "@oebb-web-team/oebb-web-components";
import {RestService} from "../services/rest.service";
import {SessionService} from "../services/session.service";
import {findLocale, i18n} from "./I18n";

export async function loadInitData(rootElement: HTMLElement) {
    const lang = findLocale(rootElement);
    i18n.setLang(lang);

    const data = await RestService.instance.start();
	SessionService.instance.setStartData(data);
	TrainService.instance.setMaxBookableDate(data.maxBookableDate);

    return data;
}
